import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import { WEBINAR_TYPES } from 'utils/Constants';

import Show from 'components/Show';
import Pill from 'components/Misc/Pill';
import { Datepicker } from 'components/Misc/Form';
import { Title } from 'components/Misc/Typography';

const className = classnames(
	'py-2 px-3 flex items-center space-x-2 border-4 rounded-lg cursor-pointer transition-all',
	'dark:border-neutral-800 dark:bg-neutral-800 hover:dark:bg-neutral-900',
	'border-white bg-white hover:bg-neutral-50'
);

const Webinar = ({ webinar }) => {
	// Find type info
	const type = useMemo(() => WEBINAR_TYPES.find(type => type.value === webinar.type), [webinar.type]);

	return (
		<Link to={`/webinars/${webinar.id}`} className={className}>
			<Title
				title={webinar?.course?.title}
				subtitle={webinar?.subject?.title}
				className="flex-1 whitespace-nowrap text-ellipsis overflow-hidden"
			/>

			{/* Show date if webinar will be online */}
			<Show if={webinar.type === 'online'}>
				<Datepicker
					time
					readOnly
					value={webinar.eventAt}
				/>
			</Show>

			{/* Show pill if webinar is a vod */}
			<Show if={webinar.type === 'record'}>
				<Pill name={type?.text} theme="informative" />
			</Show>
		</Link>
	);
};

export default Webinar;